import produce from 'immer';

import {assert} from 'Asserts';
import {FormActionConfigInput} from 'forms/form-designer/Constants';
import {FormDefinitionContent} from 'forms/form-designer/Constants';
import {CREATE_TASK_ACTION} from 'forms/form-designer/FormDesigner';
import {
  FormDefinitionFieldWithSectionKey,
  unnestFieldsFromSections,
} from 'forms/form-designer/FormDesignerState';
import {
  FieldKeyToTableColumnIndex,
  FormInstanceComputedTableState,
  FormInstanceTableState,
} from 'forms/form-instance/Constants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {EvaluatedTable} from 'notebook/tables/excess/Evaluator';
import {ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';

export const CREATE_TASK_ASSIGNEE_PARAMETER_ID = 'task_assignee';

export function initializeCreateProcessModalFormInstanceTableState(
  table: ProcessTaskStructuredTable,
  formDefinitionContent: FormDefinitionContent,
  fieldKeyToTableColumnIndex: FieldKeyToTableColumnIndex
): FormInstanceTableState {
  const allDefinitionFields: Array<FormDefinitionFieldWithSectionKey> =
    formDefinitionContent.sections.flatMap((section) => unnestFieldsFromSections(section));
  const tableState = {
    [CREATE_TASK_ACTION.identifier]: produce(table, (tableDraft) => {
      allDefinitionFields.forEach((field) => {
        if (
          fieldKeyToTableColumnIndex[field.key] &&
          fieldKeyToTableColumnIndex[field.key][0] === CREATE_TASK_ACTION.identifier
        ) {
          const [, columnIndex] = fieldKeyToTableColumnIndex[field.key];
          tableDraft.columns[columnIndex].isRequired = field.isRequired;
        }
      });
    }),
  };
  return tableState;
}

export function initializeCreateProcessModalFormInstanceComputedTableState(
  computedTable?: EvaluatedTable
): FormInstanceComputedTableState {
  return {[CREATE_TASK_ACTION.identifier]: computedTable ?? [[]]};
}

export function initializeCreateProcessModalFieldKeyToTableColumnIndex(
  table: ProcessTaskStructuredTable,
  formActionConfigs: Array<FormActionConfigInput>
): FieldKeyToTableColumnIndex {
  assert(formActionConfigs.length === 1, 'CreateProcessModal Forms must have only 1 Action Config');
  assert(
    formActionConfigs[0].identifier === CREATE_TASK_ACTION.identifier,
    'CreateProcessModal Forms Action Config must be "create_task"'
  );
  const schemaFieldIdToTableColumnIndex = table.columns.reduce<Record<string, [string, number]>>(
    (accumulator, column, index) => {
      if (column.columnType === TableColumnType.PROCESS_TASK_ASSIGNEE) {
        accumulator[CREATE_TASK_ASSIGNEE_PARAMETER_ID] = [CREATE_TASK_ACTION.identifier, index];
      } else if (column.schemaFieldApiId) {
        accumulator[column.schemaFieldApiId] = [CREATE_TASK_ACTION.identifier, index];
      }
      return accumulator;
    },
    {}
  );
  const fieldKeyToTableColumnIndex: FieldKeyToTableColumnIndex =
    formActionConfigs[0].parameters.reduce<FieldKeyToTableColumnIndex>((accumulator, parameter) => {
      if (parameter.formFieldKey) {
        accumulator[parameter.formFieldKey] = schemaFieldIdToTableColumnIndex[parameter.actionParameterId];
      }
      return accumulator;
    }, {});

  return fieldKeyToTableColumnIndex;
}
